// extracted by mini-css-extract-plugin
export var attachment = "_oo-a";
export var emailContainer = "_oo-4";
export var emailContentPaddedContainer = "_oo-b";
export var emailHeader = "_oo-6";
export var emailIframe = "_oo-3";
export var emailInfoIcon = "_oo-9";
export var emailShortenedSummary = "_oo-e";
export var infoDropdown = "_oo-0";
export var infoRowBoundedContent = "_oo-d";
export var internal = "_oo-5";
export var merchant = "_oo-8";
export var messageInputContainer = "_oo-h";
export var normal = "_oo-7";
export var replyCard = "_oo-f";
export var subtleButton = "_oo-1";
export var subtleButtonIconContainer = "_oo-2";
export var toggleViewRepliesButton = "_oo-c";
export var wrappingText = "_oo-g";